import { useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

const ORDER = ["Vopsea", "Decolorare", "Oxidanți și activatori", "Îngrijire lungimi", "Îngrijire scalp", "Styling", "Tratamente tehnice", "Bărbați", "Corp și față", "Altele"];

export const NONE = "__none";
export const inGama = (p, g) => (g.id === NONE ? !p?.gama : p?.gama === g.id);

export const gamasFor = (cfg, brand, ids) => {
  const byId = Object.fromEntries(cfg.products.map((p) => [p.id, p]));
  const cnt = {};
  let rest = 0;
  ids.forEach((id) => { if (!byId[id]) return; const g = byId[id].gama; if (g) cnt[g] = (cnt[g] || 0) + 1; else rest += 1; });
  const pic = (gid) => cfg.products.find((p) => p.gama === gid && p.image && ids.includes(p.id))?.image || "";
  const out = (cfg.gamas || []).filter((g) => g.brand === brand && cnt[g.id]).map((g) => ({ ...g, n: cnt[g.id], img: g.img || pic(g.id) }));
  return rest ? [...out, { id: NONE, brand, cat: "Altele", name: "Alte produse", desc: "Produse care nu sunt încă într-o gamă", n: rest }] : out;
};

export const BFGamaTiles = ({ gamas, onPick }) => {
  const [bad, setBad] = useState({});
  const cats = ORDER.filter((c) => gamas.some((g) => g.cat === c)).concat([...new Set(gamas.map((g) => g.cat))].filter((c) => !ORDER.includes(c)));
  return (
    <div className="bf-gamas" data-testid="bf-gamas">
      {cats.map((c) => (
        <section key={c} className="bf-gamas-cat" data-testid={`bf-gamas-cat-${c}`}>
          <h4>{c}</h4>
          <div className="bf-gamas-grid">
            {gamas.filter((g) => g.cat === c).map((g, i) => (
              <button key={g.id} type="button" className={`bf-gama-tile ${g.img && !bad[g.id] ? "has-img" : ""}`} style={{ animationDelay: `${i * 40}ms` }} onClick={() => onPick(g)} data-testid={`bf-gama-${g.id}`}>
                {g.img && !bad[g.id] && <span className="bf-gama-img"><img src={g.img} alt="" loading="lazy" referrerPolicy="no-referrer" onError={() => setBad((b) => ({ ...b, [g.id]: true }))} /></span>}
                <b>{g.name}</b>
                <small>{g.desc}</small>
                <em>{g.n} {g.n === 1 ? "produs" : "produse"} <ArrowRight size={14} /></em>
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export const BFGamaBack = ({ g, onBack }) => (
  <div className="bf-gama-head" data-testid="bf-gama-head">
    <button type="button" className="bf-back" onClick={onBack} data-testid="bf-gama-back"><ArrowLeft size={15} /> Înapoi la game</button>
    <div><b>{g.name}</b><small>{g.cat} · {g.desc}</small></div>
  </div>
);
